(function () {

  angular.module('MetadataProfileProvider', [])

    .constant('MetadataCustomFieldType', {
      Text: 'TEXT',
      Lookup: 'LOOKUP',
      Date: 'DATE'
    })

    .constant('MetadataCustomFieldValidationType', {
      Numeric: 'NUMERIC',
      Regex: 'REGEX',
      Email: 'EMAIL',
      Url: 'URL'
    })

    .factory('MetadataProfileRequest', function () {
      return function (displayName, customFields) {

        this.displayName = displayName;   // string, notblank
        this.customFields = customFields; // array of MetadataCustomFieldRequest objects, notnull

        return this;
      };
    })

    .factory('MetadataCustomFieldRequest', function () {
      return function () {

        this.id = undefined;           // string, nullable
        this.name = undefined;         // string, notblank
        this.type = undefined;         // string, notnull, MetadataCustomFieldType
        this.displayName = undefined;  // string, notblank
        this.defaultValue = undefined; // string, nullable
        this.required = false;         // boolean
        this.validation = undefined;   // MetadataCustomFieldValidationRequest object, nullable
        this.dataSourceId = undefined; // string, nullable
        this.format = undefined;       // string, nullable, used when type is 'DATE'

        return this;
      };
    })

    .factory('MetadataCustomFieldValidationRequest', function () {
      return function (type, pattern, maxDigits) {

        this.type = type;           // string, notnull, MetadataCustomFieldValidationType
        this.pattern = pattern;     // string, nullable, used when type is 'REGEX'
        this.maxDigits = maxDigits; // number, nullable, used when type is 'NUMERIC'

        return this;
      };
    })

    .service('MetadataProfileService', function ($http, $log, $q, TenantListService) {

      /**
       * @param {string} metadataProfileId The ID of the metadata profile to retrieve.
       * @returns {Promise<MetadataProfileResponse>} A promise that resolves to the metadata profile with the given ID.
       */
      this.getMetadataProfile = function (metadataProfileId) {
        const deferred = $q.defer();
        const url = `${TenantListService.currentTenant.info._links['px:metadataProfiles'].href}/${metadataProfileId}`;
        $http.get(url)
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (error) {
            $log.error('Failed to retrieve metadata profile with ID=' + metadataProfileId);
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      /**
       * @param {MetadataProfileRequest} metadataProfileRequest The metadata profile to create.
       * @returns {Promise<MetadataProfileResponse>} A promise that resolves to the created metadata profile.
       */
      this.createMetadataProfile = function (metadataProfileRequest) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:metadataProfiles'].href;
        $http.post(url, metadataProfileRequest)
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (error) {
            $log.error('Failed to create metadata profile.');
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      /**
       * @param {string} metadataProfileId The ID of the metadata profile to update.
       * @param {MetadataProfileRequest} metadataProfileRequest The metadata profile to update.
       * @returns {Promise<MetadataProfileResponse>} A promise that resolves to the updated metadata profile.
       */
      this.updateMetadataProfile = function (metadataProfileId, metadataProfileRequest) {
        const deferred = $q.defer();
        const url = `${TenantListService.currentTenant.info._links['px:metadataProfiles'].href}/${metadataProfileId}`;
        $http.put(url, metadataProfileRequest)
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (error) {
            $log.error('Failed to update metadata profile with ID=' + metadataProfileId);
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      /**
       * @param {string} metadataProfileId The ID of the metadata profile to delete.
       * @returns {Promise} A promise that resolves when the metadata profile is deleted.
       */
      this.deleteMetadataProfile = function (metadataProfileId) {
        const deferred = $q.defer();
        const url = `${TenantListService.currentTenant.info._links['px:metadataProfiles'].href}/${metadataProfileId}`;
        $http.delete(url)
          .then(function (response) {
            deferred.resolve();
          })
          .catch(function (error) {
            $log.error('Failed to delete metadata profile with ID=' + metadataProfileId);
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      return this;
    });

})();
